export default __webpack_public_path__ + "static/media/wave_top.551d60fc.png";